import { apis } from 'utils/lib/apis';
import queryString from 'query-string';

class SchoologyAPI {
  
  getRequestToken = async() => {
    return apis.get('schoologyRDS', `/requestToken`).then((data) => {
      if (data && !data.error) {
        const token = queryString.parse(data)
        return token
      }
      return null
    })
  }

  getAccessToken = async(requestToken) => {
    return apis.post('schoologyRDS', `/acessToken`,{
      body:requestToken
    }).then((data) => {
      if (data && !data.error) {
        const token = queryString.parse(data)
        localStorage.setItem('token', JSON.stringify(token))
        return token
      }
      return null
    })
  }
}

export default SchoologyAPI
